import monthsLibrary from './libraries/months'
import randomInt from 'random-int'

/**
 * Get a random or specific month
 * @return string
 * @param n
 */
const month = ( n = undefined ) => {
  const number = n || randomInt( 1, 12 )

  if ( typeof number !== 'number' ) {
    throw new TypeError( 'Invalid argument provided for a month' )
  }

  return monthsLibrary[ number - 1 ]
}

export default month



// WEBPACK FOOTER //
// ./src/month.js